module.exports = __webpack_public_path__ + "static/media/purchase-record-black.fa505090.svg";